__turbopack_context__.v({
  "className": "noto_sans_1ed30c33-module__IxKkoa__className",
  "variable": "noto_sans_1ed30c33-module__IxKkoa__variable",
});
